import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=1e80bb4a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=1e80bb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80bb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e80bb4a')) {
      api.createRecord('1e80bb4a', component.options)
    } else {
      api.reload('1e80bb4a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=1e80bb4a&scoped=true&", function () {
      api.rerender('1e80bb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QECLCaU8AzT6/JS/comp/PopupDialog.vue"
export default component.exports